module.exports = __webpack_public_path__ + "img/avatar2.4a393468.png";